<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
    class="m-edition-section-content-subject"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyShoppingRecord"
    class="m-edition-section-content-subject"
  >
    <div class="m-edition-billing-my-shopping-record-info">
      <div class="m-edition-billing-my-shopping-record-info-left">
        <div class="m-card-record-info">
          <h4>{{ $t('mEditionBillingMyShoppingRecord.infoLeft.title') }}</h4>
          <p>
            <span :class="iconClass">
              <i class="fas fa-history"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.labelState') }}
              <span :class="[$filters.getSaleStateValue(compra.compra.compra_estado, 'class'), 'font-weight-bold']">
                {{ $filters.getSaleStateValue(compra.compra.compra_estado, 'name') }}
              </span>
               {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.fromDate') }}
               <span class="text-transform-capitalize">
                 {{ $moment.parseZone(compra.compra.compra_fecha_estado).format('D MMMM, YYYY') }}
               </span>
            </span>
          </p>
          <p v-if="compra.compra.fecha_cancelar_venta">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.cancelDate') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(compra.compra.fecha_cancelar_venta).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p>
            <span :class="iconClass">
              <i class="fas fa-receipt"></i>
            </span>
            <span>
              {{ compra.compra.concepto_compra }}
            </span>
          </p>
          <p v-if="compra.compra.id_plan && compra.compra.precio">
            <span :class="iconClass">
              <i class="fas fa-dollar-sign"></i>
            </span>
            <span v-if="compra.compra.compra_estado === 4 || compra.compra.compra_estado === 5">
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.total') }} {{ compra.compra.divisa }}
              <span class="font-weight-bold">
                {{ compra.compra.total.toFixed(2) }}
              </span>
              <span class="text-color-black-35">
                {{ compra.compra.divisa_iso_code }}
              </span>
            </span>
            <span v-else-if="compra.compra.pago_cuotas">
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.montoParcial') }} {{ compra.compra.divisa }}
              <span class="font-weight-bold">
                {{ compra.compra.total.toFixed(2) }}
              </span>
              <span>
                {{ compra.compra.divisa_iso_code }}
              </span>
              <span class="text-color-black-35">&sol;
                {{ compra.compra.divisa }}
                {{ (compra.compra.precio * compra.compra.pago_cuotas).toFixed(2) }}
                {{ compra.compra.divisa_iso_code }}
              </span>
            </span>
            <span v-else>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.montoParcial') }} {{ compra.compra.divisa }}
              <span class="font-weight-bold">
                {{ compra.compra.total.toFixed(2) }}
              </span>
              <span class="text-color-black-35">
                {{ compra.compra.divisa_iso_code }}
              </span>
            </span>
          </p>
          <p v-else>
            <span :class="iconClass">
              <i class="fas fa-dollar-sign"></i>
            </span>
            <span class="font-weight-bold">
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.free') }}
            </span>
          </p>
          <p v-if="compra.compra.id_plan && compra.compra.precio">
            <span :class="iconClass">
              <i class="far fa-credit-card"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.plan.first') }}
              <span class="font-weight-bold">
              {{ getPaymentFrequency(compra.compra.pago_cuotas, compra.compra.pago_frecuencia, compra.compra.pago_intervalo) }}
              {{ compra.compra.divisa }}
              {{ compra.compra.precio.toFixed(2) }}
            </span>
              <span class="text-color-black-35">
                {{ compra.compra.divisa_iso_code }}
              </span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.plan.second') }} {{ compra.compra.medio_pago }}
            </span>
          </p>
          <p v-if="compra.compra.trial_precio">
            <span :class="iconClass">
              <i class="far fa-clock"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.trialPay') }}
              <span class="font-weight-bold">
               {{ compra.compra.divisa }}
               {{ compra.compra.trial_precio.toFixed(2) }}
              </span>
                <span class="text-color-black-35">
                  {{ compra.compra.divisa_iso_code }}
                </span>
                con {{ compra.compra.medio_pago }}
            </span>
          </p>
          <p v-if="compra.compra.trial_intervalo">
            <span :class="iconClass">
              <i class="far fa-clock"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.trial') }}
              <span class="font-weight-bold">
                {{ compra.compra.trial_intervalo }}
                {{ $filters.getFrequencyValue(compra.compra.trial_frecuencia, 'name') }}
              </span>
            </span>
          </p>
          <p v-if="compra.compra.cupon_codigo">
            <span :class="iconClass">
              <i class="fas fa-percentage"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.cupon.linea1First') }}
              <span class="font-weight-bold">
                {{ compra.compra.cupon_codigo }}
              </span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.cupon.linea1Second') }}
              <span class="font-weight-bold">
                {{ compra.compra.cupon_monto }}%
              </span>
            </span>
          </p>
          <p v-if="compra.iva">
            <span :class="iconClass">
              <i class="fas fa-percentage"></i>
            </span>
            <span>{{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.iva') }}
              <span>
                {{ compra.iva }}%
              </span>
            </span>
          </p>
          <p v-if="compra.compra.medio_pago && compra.compra.id_externo">
            <span :class="iconClass">
              <i class="fas fa-key"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.suscripcion.idExterno') }}
              {{ compra.compra.medio_pago }}
              <i class="text-color-black-65 font-weight-bold">
                {{ compra.compra.id_externo }}
              </i>
            </span>
          </p>
          <p v-if="compra.compra.fecha_inicio_suscripcion && $moment.parseZone().isBefore($moment.parseZone(compra.compra.fecha_inicio_suscripcion))">
            <span :class="iconClass">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.suscripcion.payNext') }}
              <span :style="proxPagoClass">
                {{ $moment.parseZone(compra.compra.fecha_inicio_suscripcion).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-else-if="compra.compra.fecha_proximo_pago">
            <span :class="iconClass">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.suscripcion.payNext') }}
              <span :style="proxPagoClass">
                {{ $moment.parseZone(compra.compra.fecha_proximo_pago).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p
            v-if="compra.proyectos && compra.proyectos.length"
            style="align-items:baseline !important;"
          >
            <span :class="iconClass">
              <i class="fas fa-list"></i>
            </span>
            <span>
              <ul style="list-style: none; margin: 0; padding: 0;">
                <li style="padding-bottom: 10px"><span class="font-weight-bold">{{ $t('mEditionBillingMyShoppingRecord.infoLeft.compra.proyectos') }}</span></li>
                <li
                  v-for="(proyecto, index) in compra.proyectos"
                  :key="index"
                  style="font-style: italic; padding-bottom: 5px;">
                  - {{ proyecto.titulo}}
                </li>
              </ul>
            </span>
          </p>
        </div>
      </div>

      <div class="m-edition-billing-my-shopping-record-info-right">
        <div
          v-if="verifyShowChangePaymentMethodCard"
          class="m-card-primary m-card-transition m-card-record-link width-auto"
        >
          <div v-if="suscripcionNotificada">
            <p>{{ $t('mEditionBillingMyShoppingRecord.infoRight.payMethodChange.pending.paragraph') }}</p>
            <a
              :class="payMethodClass"
              @click="modalViewPendingPayMethodsChange({
              'suscripcion': suscripcionNotificada,
              'compra': compra.compra
            })"
            >
              {{ $t('mEditionBillingMyShoppingRecord.infoRight.payMethodChange.pending.btn') }}
            </a>
          </div>
          <div v-else>
            <p>
              {{ $t('mEditionBillingMyShoppingRecord.infoRight.payMethodChange.paragraph') }}
            </p>
            <p
              :class="payMethodClass"
              @click="modalPaymentMethod({
                gateways: pasarelas,
                pasarela: compra.compra.medio_pago,
                plan: compra.compra.id_plan,
                producto: compra.compra.producto_compra,
                venta: compra.compra.id_compra,
              })"
            >
              {{ $t('mEditionBillingMyShoppingRecord.infoRight.payMethodChange.btn') }}
            </p>
          </div>
        </div>
        <div class="m-card-record-info width-auto">
          <div class="d-flex justify-content-between align-items-center">
            <header class="m-edition-billing-my-shopping-record-header">
              <h4 class="font-weight-bold">
                {{ $t('mEditionBillingMyShoppingRecord.infoRight.invoiceData.title') }}
              </h4>
              <AtomButtonIconRounded
                :button-icon-rounded="buttonIconRounded.edit"
                @gotToBillingData="gotToBillingData()"
              />
            </header>
          </div>
          <p class="display-block mt-3">{{
              compra.cliente.datos_personales.razon_social
            }}&nbsp;&bull;&nbsp;{{ compra.cliente.email }}</p>
          <p class="display-block">
            <span>
              {{ $filters.getPersonValue(+compra.cliente.datos_personales.fisica, 'name') }}&nbsp;
            </span>
            <span v-if="(compra.cliente.datos_personales.documento && compra.cliente.datos_personales.documento.numero) && (compra.cliente.datos_personales.documento.numero !== '0' && compra.cliente.datos_personales.documento.numero !== 0)">
              &bull;&nbsp;
            </span>
            <span v-if="compra.cliente.datos_personales.documento && compra.cliente.datos_personales.documento.tipo.id_documento_tipo !== 1 &&  compra.cliente.datos_personales.documento.tipo.nombre !== 'ID' && compra.cliente.datos_personales.documento.numero">
              {{ compra.cliente.datos_personales.documento.tipo.nombre }}
              {{ compra.cliente.datos_personales.documento.numero }}
            </span>
          </p>
          <p class="display-block">
            <span> {{ compra.cliente.datos_personales.domicilio.provincia.pais.nombre }} </span>
            <span>, {{ compra.cliente.datos_personales.domicilio.provincia.nombre }} </span>
            <span v-if="compra.cliente.datos_personales.domicilio.localidad">
              , {{ compra.cliente.datos_personales.domicilio.localidad }}
            </span>
            <span v-if="compra.cliente.datos_personales.domicilio.codigo_postal">
              , {{ compra.cliente.datos_personales.domicilio.codigo_postal }}
              </span>
            <span v-if="compra.cliente.datos_personales.domicilio.linea1">
              , {{ compra.cliente.datos_personales.domicilio.linea1 }} </span>
            <span v-if="compra.cliente.datos_personales.domicilio.linea2">
              {{ compra.cliente.datos_personales.domicilio.linea2 }} </span>
          </p>
          <p class="display-block">
            <span v-if="compra.cliente.datos_personales.telefono">
              {{ $t('mEditionBillingMyShoppingRecord.infoRight.invoiceData.tel') }}
              {{ compra.cliente.datos_personales.telefono }}
            </span>
            <span v-if="compra.cliente.datos_personales.telefono && compra.cliente.datos_personales.movil">
              &nbsp;&bull;&nbsp;
            </span>
            <span v-if="compra.cliente.datos_personales.movil">
              {{ $t('mEditionBillingMyShoppingRecord.infoRight.invoiceData.movil') }}
              {{ compra.cliente.datos_personales.movil }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <h4
      v-show="pagos.length"
      class="font-weight-bold"
    >
      {{ $t('mEditionBillingMyShoppingRecord.table.title') }}
    </h4>
    <div
      v-show="pagos.length"
      class="m-table-secondary">
      <table class="table-layout-fixed">
        <tr>
          <th
            class="text-align-left"
            width="13%"
          >
            {{ $t('mEditionBillingMyShoppingRecord.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionBillingMyShoppingRecord.table.thState') }}
          </th>
          <th
            class="text-align-center"
            width="9%"
          >
            {{ $t('mEditionBillingMyShoppingRecord.table.thTax') }}
          </th>
          <th
            class="text-align-rigth"
            width="16%"
          >
            {{ $t('mEditionBillingMyShoppingRecord.table.thAmount') }}
          </th>
          <th
            class="text-align-center"
            width="19%"
          >
            {{ $t('mEditionBillingMyShoppingRecord.table.thMethod') }}
          </th>
          <th
            class="text-align-center"
            width="15%"
          >
            {{ $t('mEditionBillingMyShoppingRecord.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionBillingMyShoppingRecord.table.thInvoice') }}
          </th>
        </tr>
        <tr
          v-for="(pago, index) in pagos"
          :key="index"
          class="row-data"
        >
          <td
            class="text-align-left text-transform-capitalize text-white-space-nowrap">
            {{ paymentDate(pago) }}
          </td>
          <td class="text-align-center">
            <span :class="[$filters.getPaymentStateValue(pago.pago_estado, 'class'), 'font-weight-bold']">
              {{ $filters.getPaymentStateValue(pago.pago_estado, 'name') }}
            </span>
          </td>
          <td class="text-align-center">
            <span class="text-color-black-35">{{ `(${pago.tipo_impuesto})` }}</span> {{ pago.impuesto }}%
          </td>
          <td class="text-align-center">
            {{ pago.divisa_simbolo }} {{ pago.monto.toFixed(2) }} <span class="text-color-black-35"> {{ pago.divisa }}</span>
          </td>
          <td class="text-align-center">
            {{ pago.medio_pago }}
          </td>
          <td class="text-align-center">
            <span v-if="showLoading">
              <i
                key="loadingIcon"
                class="fas fa-spinner fa-spin"
                style="color: var(--color-brand-billing-primary)"
              >
              </i>
            </span>
            <span v-else>
              {{ getDetalleAPagar(pago.plan_cuotas, pago.trial_pago !== undefined ? pago.trial_pago : false, index) }}
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.invoice"
              @gotToInvoice="gotToInvoice(pago, index)"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyShoppingRecord',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      divisa: null,
      divisas: [],

      filter: {
        limite: 10,
        pagina: 1
      },

      minExpireDate: '',

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        showLoadingState: false,
        limit: 10,
        totalPages: 1,
        totalQuantity: 0
      },

      pagos: [],
      pasarelas: [],
      productoGestion: null,
      posi: 0,

      showLoadingState: 0,
      showLoading: true,
      suscripcionNotificada: null,

      trialPago: false,

      compra: {}
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    },

    theme () {
      return this.academyDataColor ? 'academy' : 'billing'
    },

    buttonIconRounded () {
      return {
        edit: {
          class: `a-button-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom a-button-${this.theme}-secondary`,
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'gotToBillingData',
          tooltip: this.$t('mEditionBillingMyShoppingRecord.tooltips.edit'),
          type: 'button'
        },

        disabled: {
          class: `a-button-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom a-button-disabled-secondary a-button-${this.theme}-secondary`,
          component: '',
          icon: 'fas fa-undo-alt',
          method: '',
          type: 'button'
        },

        invoice: {
          class: `a-button-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom a-button-${this.theme}-secondary`,
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToInvoice',
          tooltip: this.$t('mEditionBillingMyShoppingRecord.tooltips.shopping'),
          type: 'button'
        }
      }
    },

    iconClass () {
      return `info-icon-left info-icon-${this.theme}`
    },

    payMethodClass () {
      return `margin-top-medium display-flex-row recod-link-call-to-action recod-link-call-to-action-${this.theme}`
    },

    proxPagoClass () {
      return `border-bottom: 1px dashed var(--color-brand-${this.theme}-primary);`
    },

    updatedData () {
      return this.$modal.updatedData
    },

    verifyPaypalCredentials () {
      return this.pasarelas.length
        ? this.pasarelas.find(p => this.compra.compra.id_academia_pasarela_pago === Number(p.id_academia_pasarela_pago)).configuracion.buissnes_id
        : false
    },

    verifyShowChangePaymentMethodCard () {
      if (!this.compra || !this.compra.compra) {
        return false
      }

      const compra = this.compra.compra

      const isPaymentMethodValid = (compra.medio_pago !== 'Paypal' || (compra.medio_pago === 'Paypal' && this.verifyPaypalCredentials))

      return compra.compra_estado !== 4 &&
        !!compra.medio_pago &&
        compra.pago_cuotas !== 1 &&
        isPaymentMethodValid
    }
  },

  created () {
    this.readCompra()
    this.readVentaPagos()
  },

  watch: {
    'pagination.currentPage' () {
      this.showLoading = true
      this.posi = this.pagination.currentPage === 1 ? 0 : (this.filter.limite * (this.pagination.currentPage - 1))
    },

    updatedData () {
      this.readVentaPagos(false)
    }
  },

  methods: {
    getDetalleAPagar (cuotas, trial, index) {
      return trial
        ? 'Trial'
        : cuotas === 1
          ? 'Contado'
          : cuotas === 0
            ? `Pago ${(this.pagination.totalQuantity - index) - this.posi}`
            : `Cuota ${(this.pagination.totalQuantity - index) - this.posi} de ${cuotas}`
    },

    getPaymentFrequency (cuotas, frecuencia, intervalo) {
      return cuotas === 1
        ? '1 pago de'
        : cuotas === 0
          ? `1 pago cada ${intervalo || 1} ${this.$filters.getFrequencyValue(frecuencia, 'name')}`
          : `${cuotas} cuotas mensuales`
    },

    getTotalVenta (total = 0, monto, trial, cuotas) {
      return !cuotas
        ? total
        : this.trialPago
          ? (cuotas * monto) + trial
          : (cuotas * monto)
    },

    gotToBillingData () {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myShopping.subject')}/${this.$route.params.subid}/${this.$t('mEditionMenu.billing.myShopping.children.dataInvoice.subedition')}`)
    },

    gotToInvoice (pago, index) {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myShopping.subject')}/${this.$route.params.subid}/${this.$t('mEditionMenu.billing.myShopping.children.invoice.subedition')}/${pago.id_pago}`)
    },

    paymentDate (pago) {
      if (pago.pago_estado === 0) {
        return this.$moment.parseZone(pago.fecha_pago_vencimiento).subtract(5, 'days').format('D MMM YYYY')
      } else if (pago.pago_estado === 2) {
        return this.$moment.parseZone(pago.fecha_pago).format('D MMM YYYY')
      } else {
        return this.$moment.parseZone(pago.fecha_estado).format('D MMM YYYY')
      }
    },

    readCompra () {
      this.$services.read('ventas', 'readCompra', {}, [this.$store.getters.getAcademyData.id, this.$route.params.subid])
        .then(response => {
          this.compra = response.data
          this.readSubscriptionNotificada()
          this.readDivisas()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readVentaPagos (alert = true) {
      if (!this.pagination.showLoadingState) {
        alert
          ? this.pagination.showLoadingState = true
          : this.pagination.showLoadingState = false
        this.$services.read('ventas', 'readVentaPagos', {}, [this.$route.params.subid], this.filter)
          .then(response => {
            this.pagos = response.data.pagos
            if (this.pagos.find(p => p.trial_pago === true) !== undefined) {
              this.trialPago = true
            }
            if (!alert) {
              setTimeout(this.readVenta(), 3000)
            }
            this.pagination.currentQuantity = response.data.pagos.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState++
            this.showLoading = false
          })
          .catch(error => {
            console.log(error)
            this.pagos = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
      }
    },

    reloadListing () {
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readVentaPagos()
    },

    modalPaymentMethod (params) {
      this.$modal.showModal('MoleculeEditionBillingMyShoppingChangeModalPayMethods', params)
    },

    modalViewPendingPayMethodsChange (params) {
      this.$modal.showModal('MoleculeEditionBillingMyShoppingModalPendingPayMethodsChange', params)
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.divisa = this.compra.compra.divisa_iso_code
            ? this.divisas.find(divisa => divisa.iso_code === this.compra.compra.divisa_iso_code)
            : null
          this.readProductoGestiones(this.compra.compra.producto_compra)
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readProductoGestiones (producto) {
      this.$services.read('ventas', 'readVentaProductoGestiones', {}, [producto])
        .then(response => {
          this.pasarelas = this.divisa
            ? response.data.find(p => { return p.divisa.id_divisa === this.divisa.id_divisa }).pasarelas
            : []
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readSubscriptionNotificada () {
      this.$services.read('ventas', 'readSubscriptionNotificada', {}, [ this.compra.compra.id_compra ])
        .then(response => {
          if (response.status === 204) {
            this.suscripcionNotificada = null
          } else {
            this.suscripcionNotificada = response.data
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },
    modalBillingData (params) {
      this.$modal.showModal('MoleculeEditionBillingMyShoppingChangeModalBillingData', params)
    }
  }
}
</script>
